import { render, staticRenderFns } from "./studentProfile.vue?vue&type=template&id=6ee01c4a&scoped=true"
import script from "./studentProfile.vue?vue&type=script&lang=js"
export * from "./studentProfile.vue?vue&type=script&lang=js"
import style0 from "./studentProfile.vue?vue&type=style&index=0&id=6ee01c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee01c4a",
  null
  
)

export default component.exports